import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { Mail, Phone, MapPin, Linkedin, Twitter, Github, Send } from 'lucide-react';
import '../styles/Footer.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Footer = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      toast.success('Successfully subscribed to newsletter!');
      setEmail('');
    } catch (error) {
      toast.error('Failed to subscribe. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const footerLinks = {
    Company: [
      { label: 'About Us', path: '/about' },
      { label: 'Services', path: '/services' },
      { label: 'Portfolio', path: '/work' },
      { label: 'Blog', path: '/blog' }
    ],
    Services: [
      { label: 'App Development', path: '/services/app-development' },
      { label: 'Web Development', path: '/services/web-development' },
      { label: 'SEO & Growth', path: '/services/seo' },
      { label: 'UI/UX Design', path: '/services/ui-ux' }
    ],
    Resources: [
      { label: 'Pricing', path: '/pricing' },
      { label: 'Contact', path: '/contact' },
      { label: 'Privacy Policy', path: '/privacy' },
      { label: 'Terms of Service', path: '/terms' }
    ]
  };

  return (
    <footer className="footer" data-testid="footer">
      <div className="container">
        <div className="footer-content">
          
          {/* LOGO SECTION */}
          <div className="footer-section footer-about">
            <img 
              src="/assets/logo1.png" 
              alt="BigSoftTech Logo" 
              className="footer-logo-img"
            />

            <p className="footer-description">
              We help businesses ship product-grade software and grow with measurable SEO and analytics.
            </p>

            <div className="footer-social">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                <Linkedin size={20} />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                <Twitter size={20} />
              </a>
              <a href="https://github.com" target="_blank" rel="noopener noreferrer">
                <Github size={20} />
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([category, links]) => (
            <div className="footer-section" key={category}>
              <h4 className="footer-title">{category}</h4>
              <ul className="footer-links">
                {links.map((link) => (
                  <li key={link.path}>
                    <Link to={link.path}>{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Newsletter */}
          <div className="footer-section footer-newsletter">
            <h4 className="footer-title">Stay Updated</h4>
            <p>Subscribe to our newsletter for the latest updates and insights.</p>

            <form className="newsletter-form" onSubmit={handleNewsletterSubmit}>
              <input
                type="email"
                placeholder="Your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
              />
              <button type="submit" disabled={loading} className="newsletter-button">
                {loading ? <div className="spinner" /> : <Send size={18} />}
              </button>
            </form>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-contact">
            <div className="contact-item">
              <Mail size={16} />
              <a href="mailto:contact@BigSoftTech.in">contact@BigSoftTech.in</a>
            </div>
            <div className="contact-item">
              <Phone size={16} />
              <a href="tel:+9105324050303">05324050303</a>
            </div>
            <div className="contact-item">
              <MapPin size={16} />
              <span>Prayagraj & Noida, India</span>
            </div>
          </div>

          <div className="footer-copyright">
            <p>&copy; {new Date().getFullYear()} BigSoftTech. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
